import type { MtoMaterialPosition, MtoRun, NsiMapping } from '@entities/mto';

/** Строк на странице таблицы: ведомость объекта бывает на тысячи строк. */
export const PAGE = 200;

export type Tab = 'materials' | 'rebar' | 'tables' | 'works';

export const TAB_LABEL: Record<Tab, string> = {
  materials: 'Материалы',
  rebar: 'Свод арматуры',
  tables: 'Таблицы из файлов',
  works: 'Работы из ВОР',
};

export interface MtoVedomostViewProps {
  run: MtoRun;
  materials: MtoMaterialPosition[];
  mappings: NsiMapping[];
  canWrite: boolean;
}
